let _ = t => t,
  _t;
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { H1 } from 'UIComponents/elements/headings';
import UIImage from 'UIComponents/image/UIImage';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from 'styled-components';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { GENERAL } from 'self-service-api/constants/UpgradeProducts';
import { ASSIGN_SEAT, REQUEST_SEAT } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import breakpoint from 'pricing-pages-ui/js/constants/Breakpoints';
import { POINT_TYPES } from 'ui-addon-upgrades/ums/types';
import { APP } from '../constants/tracking/App';
import { HubProductHeader } from './HubProductHeader';
import UpgradePageMerchCard from './UpgradePageMerchCard';
import LimitUsageBannerRow from './limit-usage/LimitUsageBannerRow';

// @ts-expect-error svg import
import USAGE_LIMIT_SVG from 'bender-url!pricing-pages-ui/img/upgradePage/usage-limit-banner.svg';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { SCREENS } from '../constants/tracking/Locations';
import { parseNumber } from './utils/numberUtils';
import MC0653HubProductHeader from './mc0653/MC0653HubProductHeader';
import { isMc0653UpgradeKey } from './mc0653/mc0653Constants';
import { getHasSeatPurchaseMotions } from './utils/getHasSeatPurchaseMotions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlexContainer = styled(UIFlex).withConfig({
  displayName: "UpgradeConfigBannerContent__FlexContainer",
  componentId: "sc-1a01ab0-0"
})(["z-index:1;", ";"], breakpoint.tablet(_t || (_t = _`
    padding-right: 48px;
    padding-left: 48px;
  `)));
const UpgradeConfigBannerContent = ({
  upgradePointApiName,
  upgradeConfig,
  purchaseMotions,
  handlePurchaseMotionButtonClick
}) => {
  const {
    limit,
    value
  } = getQueryParams();
  const parsedLimit = parseNumber(limit);
  const parsedUsage = parseNumber(value);
  const upgradeData = {
    app: APP,
    screen: SCREENS.UPGRADE_PAGE,
    uniqueId: upgradeConfig.upgradeKey,
    upgradeProduct: ApiNameToUpgradeProductMap[upgradePointApiName] || GENERAL,
    apiName: upgradePointApiName,
    //The upgradeSource will always equal the upgradeKey in banners
    upgradeSource: upgradeConfig.upgradeKey,
    feature: upgradeConfig.feature
  };
  const titleTranslationKey = isValidI18nKey(`ebxInterstitialPage.hero-banner.${upgradeConfig.upgradeKey}`) ? `ebxInterstitialPage.hero-banner.${upgradeConfig.upgradeKey}` : `ebxInterstitialPage.hero-banner.default`;
  const hideHubProductHeader = getHasSeatPurchaseMotions(purchaseMotions);
  return /*#__PURE__*/_jsxs(FlexContainer, {
    justify: "between",
    align: "center",
    className: "p-bottom-12",
    style: {
      paddingTop: '72px'
    },
    children: [/*#__PURE__*/_jsxs(UIBox, {
      grow: 1,
      basis: "50%",
      className: "p-right-4",
      children: [/*#__PURE__*/_jsx(H1, {
        className: "m-bottom-10",
        children: isMc0653UpgradeKey(upgradeConfig.upgradeKey) ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ebxInterstitialPage.mc0653.header"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: titleTranslationKey
        })
      }), purchaseMotions.includes(REQUEST_SEAT) && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ebxInterstitialPage.requestSeat.requestAccessText",
          options: {
            productName: I18n.text(`upgrades.products.${upgradePointApiName}`)
          }
        })
      }), purchaseMotions.includes(ASSIGN_SEAT) && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ebxInterstitialPage.assignSeat.assignSeatText",
          options: {
            productName: I18n.text(`upgrades.products.${upgradePointApiName}`)
          }
        })
      }), !hideHubProductHeader && /*#__PURE__*/_jsx("b", {
        children: isMc0653UpgradeKey(upgradeConfig.upgradeKey) ? /*#__PURE__*/_jsx(MC0653HubProductHeader, {
          apiName: upgradePointApiName,
          showIcon: false
        }) : /*#__PURE__*/_jsx(HubProductHeader, {
          apiName: upgradePointApiName,
          showIcon: false
        })
      }), upgradeConfig.pointType === POINT_TYPES.USAGE_LIMIT_BANNER && parsedLimit && parsedUsage !== null && /*#__PURE__*/_jsx(LimitUsageBannerRow, {
        limit: parsedLimit,
        usage: parsedUsage,
        upgradeConfig: upgradeConfig
      }), /*#__PURE__*/_jsx(UpgradePageMerchCard, {
        purchaseMotions: purchaseMotions,
        upgradeData: upgradeData,
        upgradePointApiName: upgradePointApiName,
        handlePurchaseMotionButtonClick: handlePurchaseMotionButtonClick
      })]
    }), /*#__PURE__*/_jsx(UIBox, {
      grow: 0,
      basis: "50%",
      className: "p-left-4",
      children: /*#__PURE__*/_jsx("div", {
        className: "text-center m-x-0 m-y-auto",
        children: /*#__PURE__*/_jsx(UIImage, {
          src: USAGE_LIMIT_SVG,
          style: {
            maxHeight: '400px'
          },
          className: "m-bottom-4"
        })
      })
    })]
  });
};
export default UpgradeConfigBannerContent;